import Api from '../utils/Api';
import Config from '../config/Config';

class MotivoRechazoService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'rechazos' }, { name: 'abandono' }]);
  }

  buscarMotivo() {
    return this.api.endpoints.rechazos
      .get()
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  enviarMotivo(idMotivoRechazo, idEtapa, trackId) {
    const bodyRequest = {
      params: {
        idMotivoRechazo,
        idEtapa
      }
    };
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.abandono
      .update(bodyRequest, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

export default new MotivoRechazoService;